import { API_URLS } from "../constants";
import apiClient from "./interceptor";
import { encryptAES } from './crypto';
import JSZip from "jszip";
import { saveAs } from "file-saver";

export const login = async (loginParams) => {
    try {
        const secretKey = process.env.REACT_APP_SECRET_KEY || "";
        const encryptedData = await encryptAES(loginParams.password, secretKey);
        const loginPayloadParams = {
            user_name: loginParams.user_name,
            iv_hex: encryptedData.iv,
            encrypted_hex: encryptedData.encrypted,
        };

        const response = await apiClient.post(API_URLS.AUTH.LOGIN, loginPayloadParams);
        return response.data;
    } catch (error) {
        console.error("Error logging in:", error);
        throw error;
    }
};

export const changePassword = async (changePasswordParams) => {
    try {
        const secretKey = process.env.REACT_APP_SECRET_KEY || "";
        const oldEncryptedData = await encryptAES(changePasswordParams.old_password, secretKey);

        const changePasswordPayloadParams = {
            user_name: changePasswordParams.user_name,
            iv_hex_old: oldEncryptedData.iv,
            encrypted_hex_old: oldEncryptedData.encrypted,
            new_password: changePasswordParams.new_password,
        };

        const response = await apiClient.post(
            API_URLS.AUTH.CHANGE_PASSWORD,
            changePasswordPayloadParams,
            {
                headers: changePasswordParams.token
                    ? { Authorization: `Bearer ${changePasswordParams.token}` }
                    : {},
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error changing password:", error);
        throw error;
    }
};

export const getUserList = async (company_id) => {
    try {
        const response = await apiClient.get(`${API_URLS.USER.GET_USER_LIST}/${company_id}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching user list:", error);
        throw error;
    }
};


export const getUserDetailsById = async (user_id, start_date, end_date) => {
    try {
        const pay_load = {
            user_id: user_id,
            start_date: start_date,
            end_date: end_date
        }
        const response = await apiClient.post(API_URLS.USER.GET_USER_DETAILS, pay_load);
        return response
    } catch (error) {
        console.log(error);
    }
}

export const getCropsAndVarieties = async (company_id) => {
    try {
        const response = await apiClient.get(`${API_URLS.CROP_VARIETY_MACHINE.GET_CROPS_AND_VARIETIES}/${company_id}`);
        return response
    } catch (error) {
        console.log(error);
    }
}

// get all machine
export const getAllMachine = async (company_id) => {
    try {
        const response = await apiClient.get(`${API_URLS.CROP_VARIETY_MACHINE.GET_MACHINES}/${company_id}`);
        return response
    } catch (error) {
        console.log(error);
    }
}

export const getOpenScanPdf = async (scanId, subScanId, companyId) => {
    try {
        const payload = { "scan_id": scanId };
        if (subScanId) {
            payload["sub_scan_id"] = subScanId;
        }
        const response = await apiClient.post(
            API_URLS.OPEN_SCAN_PDF.GET_SCAN_PDF,
            payload,
            {
                responseType: 'blob',
                headers: {
                    'Upjao-Company-Id': companyId,
                },
            }
        );
        return response
    } catch (error) {
        console.error(error);
        return error
    }
};

// pdf view
export const getScanPdf = async (scanId, subScanId) => {
    try {
        const payload = { "scan_id": scanId };
        if (subScanId) {
            payload["sub_scan_id"] = subScanId;
        }
        const response = await apiClient.post(
            API_URLS.SCANS.GET_SCAN_PDF,
            payload,
            { responseType: 'blob' }
        );
        return response
    } catch (error) {
        console.error(error);
        return error
    }
};

// getting scans images list
export const getScanFiles = async (scanId, subScanId) => {
    try {
        const payload = { "scan_id": scanId };
        if (subScanId) {
            payload["sub_scan_id"] = subScanId;
        }
        const response = await apiClient.post(API_URLS.SCANS.GET_SCAN_FILES, payload);
        return response
    } catch (error) {
        console.error(error);
    }
}

// total scans for home page
export const getScansCount = async (company_id) => {
    try {
        const response = await apiClient.get(`${API_URLS.SCANS.GET_SCAN_COUNT}/${company_id}`);
        return response
    } catch (error) {
        console.error(error);
    }
}

// user count for home page
export const getUsersCount = async (company_id) => {
    try {
        const response = await apiClient.get(`${API_URLS.USER.GET_USER_COUNT}/${company_id}`);
        return response
    } catch (error) {
        console.error(error);
    }
}

// total scans verse crop in home
export const getScansDataUsingCrops = async (pay_load) => {
    try {
        const response = await apiClient.post(API_URLS.SCANS.GET_SCANS, pay_load);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const getScanHistory = async (payload) => {
    try {
        const response = await apiClient.post(API_URLS.SCANS.GET_SCAN_HISTORY, payload);
        return response;
    } catch (error) {
        console.error("Error fetching scan history:", error);
        throw error;
    }
};

//  generate_scan_pdf_merged_for_allScans
export const getAllScanPdf = async (pdfDataArray) => {
    try {
        const extractedDataArray = pdfDataArray.map(({ scan_id }) => ({ scan_id }));
        const pay_load = { scan_requests: extractedDataArray }
        const response = await apiClient.post(API_URLS.SCANS.GET_MULTIPLE_SCAN_PDF, pay_load, { responseType: 'blob' });
        const blob = response.data;
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'crops_pdf.zip';
        link.click();
    } catch (error) {
        console.error(error);
    }
}

export const getUserCSV = async (scanRequests, firebase_user_id) => {
    try {
        scanRequests = scanRequests.map(item => ({ 'scan_id': item.scan_id }));
        const pay_load = {
            scan_requests: scanRequests,
            firebase_user_id: firebase_user_id
        }
        const response = await apiClient.post(API_URLS.SCANS.GET_SCAN_CSV, pay_load, { responseType: 'blob' });
        const blob = response.data;
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'crop_csv.zip';
        link.click();
    } catch (error) {
        console.error(error);
    }
}

export const getCsvForAllScans = async (scanRequests, user_id, crop_name) => {
    try {
        scanRequests = scanRequests.map(item => ({ 'scan_id': item.scan_id }));
        const seenScanIds = new Set();
        const uniqueObjects = [];
        for (const obj of scanRequests) {
            const scanId = obj.scan_id;
            if (!seenScanIds.has(scanId)) {
                seenScanIds.add(scanId);
                uniqueObjects.push(obj);
            }
        }
        const pay_load = {
            scan_requests: uniqueObjects,
            user_id: user_id
        }
        const response = await apiClient.post(API_URLS.SCANS.GET_SCAN_CSV_DATA, pay_load);
        return response
    }
    catch (error) {
        console.error(error);
    }
}

export const getCompanyMetaData = async (company_id) => {
    try {
        const response = await apiClient.post(`${API_URLS.METADATA.GET_METADATA_BY_COMPANY_ID}/${company_id}`);
        return response
    } catch (error) {
        console.error(error);
    }
}
export const getDefaultMetadata = async () => {
    try {
        const response = await apiClient.get(API_URLS.METADATA.GET_ALL_GLOBAL_METADATA);
        return response
    } catch (error) {
        console.error(error);
    }
}

export const getAllDeepAnalysis = async () => {
    try {
        const response = await apiClient.get(API_URLS.DEEP_ANALYSIS.GET_ALL);
        return response;
    } catch (error) {
        console.error(error);
    }
};

// Fetch details for a specific scan/sub-scan
export const getDeepAnalysisDetails = async (scanId, subScanId) => {
    try {
        const response = await apiClient.get(
            `${API_URLS.DEEP_ANALYSIS.GET_ONE}/${scanId}/${subScanId}`
        );
        return response;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

// Update deep analysis for a specific scan/sub-scan
export const updateDeepAnalysis = async (scanId, subScanId, detail) => {
    try {
        const payload = {
            scan_id: scanId,
            sub_scan_id: Number(subScanId),
            ...detail,
        };
        const response = await apiClient.patch(API_URLS.DEEP_ANALYSIS.UPDATE, payload);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const updateScanUserMetadata = async (payload) => {
    try {
        const response = await apiClient.patch(
            API_URLS.SCANS.UPDATE_SCAN_USER_METADATA,
            payload
        );
        return response;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const downloadCompanyScanZip = async (payload) => {
    try {
        const response = await apiClient.post(
            API_URLS.SCANS.GET_COMPANY_SCAN_FILES,
            payload
        );

        const files = response.data.data;

        const zip = new JSZip();
        const grouped = files.reduce((acc, file) => {
            const id = file.scan_id || "unknown_scan";

            if (!acc[id]) acc[id] = [];
            acc[id].push(file);

            return acc;
        }, {});

        for (const scanId in grouped) {
            const scanFolder = zip.folder(scanId);
            for (const file of grouped[scanId]) {
                const res = await fetch(file.file_url);
                const blob = await res.blob();

                scanFolder.file(file.file_name, blob);
            }
        }
        const zipBlob = await zip.generateAsync({ type: "blob" });
        saveAs(zipBlob, "scans.zip");

    } catch (err) {
        console.error("ZIP download failed:", err);
    }
};

export const getSubScans = async (scan_id) => {
    try {
        const response = apiClient.get(`${API_URLS.SCANS.GET_SUB_SCANS}/${scan_id}`)
        return response
    } catch (error) {
        console.log(error);
    }
}

export const getScanDetails = async (payload) => {
    try {
        const response = await apiClient.post(API_URLS.SCANS.GET_SCAN_DETAILS, payload);
        return response
    } catch (error) {
        console.log(error);
    }
}

export const updateScanResult = async (payload) => {
    const response = await apiClient.patch(API_URLS.SCANS.UPDATE_SCAN_RESULTS, payload);
    return response;
};

export const getUpdatedScanPdf = async (scanId, sub_scan_id) => {
    try {
        const payload = { "scan_id": scanId, ...(sub_scan_id && { sub_scan_id: sub_scan_id }) };
        const response = await apiClient.post(
            API_URLS.SCANS.GET_UPDATED_SCAN_PDF,
            payload,
            { responseType: 'blob' }
        );

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = `${scanId}.pdf`;
        link.click();

        URL.revokeObjectURL(blobUrl);
        return response;
    } catch (error) {
        console.error(error);
        return error
    }
};

export const getCanvasImgData = async (imgurl, boundingBox) => {
    const canvas2d = document.createElement("canvas");
    const context = canvas2d.getContext("2d");
    context.fillStyle = "red";
    context.strokeStyle = "#FF0000";
    context.lineWidth = 20;

    const paintImage = () => {
        return new Promise((resolve) => {
            const imageObj = new Image();
            imageObj.onload = () => {
                const imgWidth = imageObj.width;
                const imgHeight = imageObj.height;

                canvas2d.width = imgWidth;
                canvas2d.height = imgHeight;
                context.strokeStyle = "#FF0000";
                context.lineWidth = 8;
                context.drawImage(imageObj, 0, 0, imgWidth, imgHeight);

                const parsedBox = JSON.parse(boundingBox);
                const boxWidth = parsedBox[2] - parsedBox[0];
                const boxHeight = parsedBox[3] - parsedBox[1];

                context.strokeRect(parsedBox[0], parsedBox[1], boxWidth, boxHeight);

                resolve(true);
            };

            imageObj.src = imgurl;
            imageObj.crossOrigin = "anonymous";
        });
    };

    const isDrawn = await paintImage();

    if (isDrawn) {
        return canvas2d.toDataURL("image/png");
    }
};


const imageCache = {};
const imageLoading = {};
const compressedImageCache = {};

const getOrLoadImage = (url) => {
    if (imageCache[url]) return Promise.resolve(imageCache[url]);
    if (imageLoading[url]) return imageLoading[url];
    imageLoading[url] = new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => { imageCache[url] = img; delete imageLoading[url]; resolve(img); };
        img.onerror = (err) => { delete imageLoading[url]; reject(err); };
        img.src = url;
    });
    return imageLoading[url];
};

// Step 1: Download full image → compress to JPEG 0.7 → cache
export const getCompressedImage = (url) => {
    if (compressedImageCache[url]) return Promise.resolve(compressedImageCache[url]);

    return getOrLoadImage(url).then((original) => {
        const canvas = document.createElement("canvas");
        canvas.width = original.naturalWidth;   // same size, no scaling
        canvas.height = original.naturalHeight;

        canvas.getContext("2d").drawImage(original, 0, 0);

        return new Promise((resolve) => {
            const compressedImg = new Image();
            compressedImg.onload = () => {
                compressedImageCache[url] = compressedImg; // cache it
                resolve(compressedImg);
            };
            compressedImg.src = canvas.toDataURL("image/jpeg", 0.5); // only compression, no resize
        });
    });
};

// Step 2: Crop from compressed image — coords unchanged (no scaling)
export const getImageFromCanvas = async (imgUrl, boundingBox) => {
    boundingBox = JSON.parse(boundingBox);

    const x = boundingBox[0];
    const y = boundingBox[1];
    const w = boundingBox[2] - boundingBox[0];
    const h = boundingBox[3] - boundingBox[1];

    const compressedImg = await getCompressedImage(imgUrl);

    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;

    canvas.getContext("2d").drawImage(
        compressedImg,
        x, y, w, h,
        0, 0, w, h
    );

    return canvas.toDataURL("image/jpeg", 0.5);
};


